import { render, staticRenderFns } from "./bidui-preview.vue?vue&type=template&id=6c1cb8bc&scoped=true&"
import script from "./bidui-preview.vue?vue&type=script&lang=ts&"
export * from "./bidui-preview.vue?vue&type=script&lang=ts&"
import style0 from "./bidui-preview.vue?vue&type=style&index=0&id=6c1cb8bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1cb8bc",
  null
  
)

export default component.exports